module.exports = __webpack_public_path__ + "img/ProcessSimulationDetails-min.73433b2f.png";